export const PARTNER_TYPE_LABELS = {
  HOLD_CO: 'HoldCo',
  AGENCY: 'Agency',
  CURATOR: 'Curator',
  PORTFOLIO: 'Portfolio'
} as const;

export const PARTNER_TYPE_TAG_CLASSES = {
  HOLD_CO: 'partner-type-holdco',
  AGENCY: 'partner-type-agency',
  CURATOR: 'partner-type-curator',
  PORTFOLIO: 'partner-type-portfolio'
} as const;

export const PARTNER_ROLE_NAMES = {
  ADMIN: 'Partner Admin',
  TRADER: 'Partner Trader',
  VIEWER: 'Partner Viewer'
} as const;

export type PartnerRoleName = typeof PARTNER_ROLE_NAMES[keyof typeof PARTNER_ROLE_NAMES];

export const PARTNER_ROLE_DESCRIPTIONS: Record<PartnerRoleName, string> = {
  [PARTNER_ROLE_NAMES.ADMIN]: 'Full access within the assigned scope, including managing portfolios and users.',
  [PARTNER_ROLE_NAMES.TRADER]: 'Can create and edit deals within the assigned scope, but cannot delete deals or manage users and settings.',
  [PARTNER_ROLE_NAMES.VIEWER]: 'Read-only access within the assigned scope.'
};

export const SCOPE_PARTNER_PREFIX = 'partner:';
export const SCOPE_PORTFOLIO_PREFIX = 'portfolio:';

export const SCOPE_TAGS = {
  holdCo: { label: PARTNER_TYPE_LABELS.HOLD_CO, cssClass: PARTNER_TYPE_TAG_CLASSES.HOLD_CO },
  agency: { label: PARTNER_TYPE_LABELS.AGENCY, cssClass: PARTNER_TYPE_TAG_CLASSES.AGENCY },
  portfolio: { label: PARTNER_TYPE_LABELS.PORTFOLIO, cssClass: PARTNER_TYPE_TAG_CLASSES.PORTFOLIO }
} as const;
